import React from 'react'
import Navbar from '../../components/Navbar'
import DealViewMetrics from '../../components/Reporting/DealViewMetrics'
import DealEngagementMetrics from '../../components/Reporting/DealEngagementMetrics'
import RedemptionMetrics from '../../components/Reporting/RedemptionMetrics'
import SMSCampaignMetrics from '../../components/Reporting/SMSCampaignMetrics'

const Reporting = () => {

  return (
    <div>
      <Navbar page={"Reporting"} />
      <div className="min-h-screen bg-white p-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-1">
            <DealViewMetrics/>
          </div>
          <div className="col-span-1">
            <DealEngagementMetrics/>
          </div>
          <div className="col-span-1">
            <RedemptionMetrics/>
          </div>
          <div className="col-span-1">
            <SMSCampaignMetrics/>
          </div>
        </div>
        
      </div>
    </div>
  )
}

export default Reporting